import React, { Suspense, useEffect, useState } from 'react';
import { Box, Breadcrumbs, CircularProgress, Grid, IconButton, Link, Stack, Switch, Tooltip, Typography } from '@mui/material';
import Interacoes from '../../components/interacoes';
import CotacoesList from '../../components/cotacoes';
import Oportunidades from '../../components/oportunidades';
import InfoContactoCliente from '../../components/infoContactoCliente';
import { useModal } from 'mui-modal-provider';
import { EditVendedorDialog } from './dialog';
import Grafico from '../../components/grafico';
import { MdiIcon } from '@components';
import { mdiChartLine, mdiChartBar, mdiTable } from '@mdi/js';
import PropostasList from '../../components/propostasList';
const CrmVendedoresDetailsView = ({ $state, CrmService, AuthorizationService }) => {
    const { showModal } = useModal();
    const [vendedor, setVendedor] = useState(null);
    const [funcionarioId, setFuncionarioId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    // Mostrar Gráficos
    const [showCharts, setShowCharts] = useState(false);
    // Mostrar Tabelas abaixo dos gráficos
    const [showTables, setShowTables] = useState(false);
    // Alterar tipo de gráfico (linhas/barras)
    const [chartType, setChartType] = useState('line');
    //dados propostas emitidas
    const [dadosPe, setDadosPe] = useState([]);
    const [labelsPe, setLabelsPe] = useState([]);
    const [loadPe, setLoadPe] = useState(true);
    //dados propostas em aberto
    const [dadosPa, setDadosPa] = useState([]);
    const [labelsPa, setLabelsPa] = useState([]);
    const [loadPa, setLoadPa] = useState(true);
    //dados volume faturado
    const [dadosVf, setDadosVf] = useState([]);
    const [labelsVf, setLabelsVf] = useState([]);
    const [loadVf, setLoadVf] = useState(true);
    //dados PCA
    const [dadosPCA, setDadosPCA] = useState([]);
    const [labelsPCA, setLabelsPCA] = useState([]);
    const [loadPCA, setLoadPCA] = useState(true);
    const arrayDeZeros = () => {
        let dados = [];
        for (let i = 0; i < 12; i++) {
            dados.push(0);
        }
        return dados;
    };
    const getLast12Months = () => {
        const monthsArray = [];
        const today = new Date();
        for (let i = 11; i >= 0; i--) {
            const date = new Date(today);
            date.setMonth(today.getMonth() - i);
            monthsArray.push(date.toISOString().substring(0, 7));
        }
        return monthsArray;
    };
    const getPropostasEmitidasVendedor = async () => {
        try {
            let pe = await CrmService.getPropostasEmitidasVendedor(vendedor.refVendedorPrimavera);
            const x = groupAndSortPropostas(pe);
            setDadosPe(x.valuesArray);
            setLabelsPe(x.monthsArray);
            setLoadPe(false);
        }
        catch (error) {
            console.log('Erro ao obter propostas emitidas', error);
        }
    };
    const getPropostasEmAbertoVendedor = async () => {
        try {
            let pa = await CrmService.getPropostasEmAbertoVendedor(vendedor.refVendedorPrimavera);
            const x = groupAndSortPropostas(pa);
            setDadosPa(x.valuesArray);
            setLabelsPa(x.monthsArray);
            setLoadPa(false);
        }
        catch (error) {
            console.log('Erro ao obter propostas emitidas', error);
        }
    };
    const getVolumeFaturadoVendedor = async () => {
        try {
            let vf = await CrmService.getVolumeFaturadoVendedor(vendedor.refVendedorPrimavera);
            const x = groupAndSortPropostas(vf);
            setDadosVf(x.valuesArray);
            setLabelsVf(x.monthsArray);
            setLoadVf(false);
        }
        catch (error) {
            console.log('Erro ao obter propostas emitidas', error);
        }
    };
    // Pedidos de cotação em aberto (estados -> em cotação, em edição dep. externo, concluído)
    const getPCAVendedor = async () => {
        try {
            let pca = await CrmService.getPCAVendedor(vendedor.funcionarioId);
            const x = groupAndSortPCA(pca);
            setDadosPCA(x.valuesArray);
            setLabelsPCA(x.monthsArray);
            setLoadPCA(false);
        }
        catch (error) {
            console.log('Erro ao obter propostas emitidas', error);
        }
    };
    // Ordenar os dados (e datas) extraír os últimos 12 meses
    const groupAndSortPropostas = (propostas) => {
        const today = new Date();
        const lastYear = new Date(today);
        lastYear.setFullYear(today.getFullYear() - 1);
        const grouped = propostas.reduce((acc, proposta) => {
            const date = new Date(proposta.data);
            const month = proposta.data.substring(0, 7); // Extrai "YYYY-MM"
            // Considera apenas os últimos 12 meses
            if (date >= lastYear && date <= today) {
                if (!acc[month]) {
                    acc[month] = 0;
                }
                acc[month] += proposta.totalmerc;
            }
            return acc;
        }, {});
        // Garante que todos os últimos 12 meses estejam no objeto, mesmo sem valores
        const monthsArray = [];
        const valuesArray = [];
        for (let i = 11; i >= 0; i--) {
            const date = new Date(today);
            date.setMonth(today.getMonth() - i);
            const monthStr = date.toISOString().substring(0, 7);
            monthsArray.push(monthStr);
            const roundedValue = (grouped[monthStr] || 0).toFixed(2);
            valuesArray.push(Number(roundedValue));
        }
        return { monthsArray, valuesArray };
    };
    const groupAndSortPCA = (pcaList) => {
        const today = new Date();
        const lastYear = new Date(today);
        lastYear.setFullYear(today.getFullYear() - 1);
        // Agrupa os dados por mês
        const grouped = pcaList.reduce((acc, pca) => {
            const date = new Date(pca.dataAbertura);
            const month = pca.dataAbertura.substring(0, 7); // Extrai "YYYY-MM"
            // Considera apenas os últimos 12 meses
            if (date >= lastYear && date <= today) {
                acc[month] = (acc[month] || 0) + 1;
            }
            return acc;
        }, {});
        // Garante que todos os últimos 12 meses estejam no objeto, mesmo sem valores
        const monthsArray = [];
        const valuesArray = [];
        for (let i = 11; i >= 0; i--) {
            const date = new Date(today);
            date.setMonth(today.getMonth() - i);
            const monthStr = date.toISOString().substring(0, 7);
            monthsArray.push(monthStr);
            valuesArray.push(grouped[monthStr] || 0);
        }
        return { monthsArray, valuesArray };
    };
    const fetchData = async () => {
        try {
            const getVendedor = await CrmService.findVendedorById($state.params.id);
            const userId = CrmService.getUserId();
            setFuncionarioId(getVendedor.funcionarioId);
            if (userId !== getVendedor.funcionarioId) {
                if (!AuthorizationService.canPerform('crmListarTodosVendedores')) {
                    $state.go('app.dashboard');
                }
            }
            setVendedor(getVendedor);
            setIsLoading(false);
        }
        catch (e) {
            console.log('Erro ao obter Vendedor: ', e);
        }
        //setIsLoading(false);
    };
    const handleData = async (values) => {
        let fetch = false;
        let uploadedFileName;
        if (!values) {
            return;
        }
        try {
            // Atualizar o contacto na tabela Funcionario (somente se existir e for diferente do atual)
            if (values?.contacto && values?.contacto !== vendedor.Funcionario.telemovel) {
                setIsLoading(true);
                fetch = true;
                await CrmService.updateFuncionario({
                    id: vendedor.Funcionario.id,
                    contacto: values.contacto
                });
            }
            // Atualizar imagem na tabela CrmVendedor (somente se existir e for diferente do atual)
            if (values?.file) {
                setIsLoading(true);
                fetch = true;
                const updatedVendedor = await CrmService.updateVendedor({
                    id: vendedor.id,
                    imagem: values.imagem
                });
                if (updatedVendedor) {
                    uploadedFileName = await handleImage(values.file);
                }
            }
        }
        catch (error) {
            console.log('Erro ao atualizar dados do vendedor:', error);
        }
        if (fetch) {
            setTimeout(() => {
                fetchData();
            }, 100);
        }
    };
    const handleEdit = (value) => {
        if (value) {
            showModal(EditVendedorDialog, {
                title: 'Editar dados do Vendedor',
                vendedor: vendedor,
                onClose: handleData
            });
        }
    };
    const handleImage = async (value) => {
        const formData = new FormData();
        console.log(value);
        formData.append('file', value);
        try {
            // upload da imagem
            const response = await fetch('/api/Upload/crm/upload', {
                method: 'POST',
                body: formData
            });
            if (!response.ok) {
                throw new Error(`Erro ao enviar imagem: ${response.statusText}`);
            }
            const content = await response.json();
            console.log('Upload bem-sucedido:', content);
            return content.result;
        }
        catch (error) {
            console.error('Erro ao enviar a imagem:', error);
            return null; // Retorna null em caso de erro
        }
    };
    const handleShowCharts = () => {
        setShowCharts(!showCharts);
    };
    useEffect(() => {
        if (!vendedor) {
            fetchData();
        }
        else {
            if (!vendedor.refVendedorPrimavera) {
                let dados = arrayDeZeros();
                let labels = getLast12Months();
                setDadosPe(dados);
                setLabelsPe(labels);
                setLoadPe(false);
                setDadosPa(dados);
                setLabelsPa(labels);
                setLoadPa(false);
                setDadosVf(dados);
                setLabelsVf(labels);
                setLoadVf(false);
            }
            else {
                getPropostasEmitidasVendedor();
                getPropostasEmAbertoVendedor();
                getVolumeFaturadoVendedor();
            }
            getPCAVendedor();
        }
    }, [vendedor]);
    return (<Box sx={{ mt: 2, pl: 1, pr: 1 }}>
      {!isLoading ? (<Box>
          <Breadcrumbs aria-label='breadcrumb'>
            <Link underline='none' color='inherit'>
              CRM
            </Link>
            <Link underline='hover' color='text.primary' href={AuthorizationService.canPerform('crmListarTodosVendedores') ? $state.href('app.crm.vendedores.list') : undefined}>
              Vendedores
            </Link>
          </Breadcrumbs>

          <Grid container sx={{ mt: 2 }}>
            <Grid item xs={12}>
              <Stack spacing={4}>
                <InfoContactoCliente $state={$state} vendedor={vendedor} edit={true} sendDatatoParent={handleEdit} handleShowChart={handleShowCharts} chartState={showCharts}></InfoContactoCliente>

                {/* TODO: Indicadores (gráficos) */}
                {showCharts ? (<Grid item xs={12}>
                    <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2}>
                      <Typography variant='h6' sx={{ color: 'black' }}>
                        Indicadores
                      </Typography>

                      <Stack direction='row'>
                        <Tooltip title={chartType === 'line' ? 'Alterar par gráfico de Barras' : 'Alterar par gráfico de Linhas'} placement='top'>
                          <IconButton onClick={() => {
                    chartType === 'line' ? setChartType('bar') : setChartType('line');
                }}>
                            <MdiIcon path={chartType === 'line' ? mdiChartLine : mdiChartBar} sx={{ color: '#0288d1' }}></MdiIcon>
                          </IconButton>
                        </Tooltip>

                        <Tooltip title={!showTables ? 'Mostrar tabelas' : 'Esconder tabelas'}>
                          <Switch onChange={() => setShowTables(!showTables)}/>
                        </Tooltip>
                        <MdiIcon path={mdiTable} sx={{ color: showTables ? '#0288d1' : 'default' }}></MdiIcon>
                      </Stack>
                    </Stack>
                    <Box>
                      <Grid item xs={12}>
                        <Grid container spacing={2} alignItems='center'>
                          {loadPe ? (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant='subtitle1'> A carregar dados de propostas emitidas</Typography>
                              <CircularProgress size={30}/>
                            </Grid>) : (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Grafico title='Valor Propostas Emitidas €' bgColor='rgba(75, 192, 75, 0.2)' borderColor='rgba(75, 192, 75, 1)' type={chartType} showTable={showTables} labels={labelsPe} values={dadosPe}/>
                            </Grid>)}

                          {loadPa ? (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant='subtitle1'> A carregar dados de propostas em aberto</Typography>
                              <CircularProgress size={30}/>
                            </Grid>) : (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Grafico title='Valor Propostas em Aberto €' bgColor='rgba(250, 20, 20, 0.2)' borderColor='rgba(250, 20, 20, 1)' type={chartType} showTable={showTables} labels={labelsPa} values={dadosPa}/>
                            </Grid>)}

                          {loadVf ? (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant='subtitle1'> A carregar dados de Volume faturado</Typography>
                              <CircularProgress size={30}/>
                            </Grid>) : (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Grafico title='Volume Faturado €' bgColor='rgba(20, 60, 245, 0.2)' borderColor='rgba(20, 60, 245, 1)' type={chartType} showTable={showTables} labels={labelsVf} values={dadosVf}/>
                            </Grid>)}

                          {loadPCA ? (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant='subtitle1'> A carregar dados de PCA</Typography>
                              <CircularProgress size={30}/>
                            </Grid>) : (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Grafico title='PCA - Pedidos de Cotação em Aberto €' bgColor='rgba(150, 0, 255, 0.2)' borderColor='rgba(150, 0, 255, 1)' type={chartType} showTable={showTables} labels={labelsPCA} values={dadosPCA}/>
                            </Grid>)}

                          <Grid item xs={false} sm={false} md={2}></Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>) : (<></>)}

                <Suspense fallback={<CircularProgress size={50}/>}>
                  <CotacoesList $state={$state} CrmService={CrmService} vendedor={funcionarioId}/>
                </Suspense>

                <Interacoes $state={$state} CrmService={CrmService} vendedor={funcionarioId}/>

                {/* TODO: Tabela de propostas */}
                <PropostasList $state={$state} CrmService={CrmService} user={$state.params.id} vendedor={funcionarioId}/>

                <Oportunidades $state={$state} CrmService={CrmService} user={$state.params.id}/>
              </Stack>
            </Grid>
          </Grid>
        </Box>) : (<Stack direction='row' justifyContent='center' alignItems='flex-start' sx={{ mt: 4 }}>
          <CircularProgress size={50}/>
        </Stack>)}
    </Box>);
};
export default CrmVendedoresDetailsView;
